var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 45,
    viewBox: "0 0 44 45",
    width: 44,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 9.20638,
    x2: 40.7948,
    y1: 34.9857,
    y2: 1.67001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4312a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25638,
    stopColor: "#6233df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#849bff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.5 11c-6.338 0-11.5 5.162-11.5 11.5s5.162 11.5 11.5 11.5h5.75v-2.3h-5.75c-5.0953 0-9.2-4.1047-9.2-9.2s4.1047-9.2 9.2-9.2 9.2 4.1047 9.2 9.2v1.725c0 .9669-.7581 1.725-1.725 1.725s-1.725-.7581-1.725-1.725v-1.725c0-3.162-2.588-5.75-5.75-5.75s-5.75 2.588-5.75 5.75 2.588 5.75 5.75 5.75c1.6256 0 3.091-.6913 4.1396-1.7856.7257 1.0736 1.9528 1.7856 3.3354 1.7856 2.2094 0 4.025-1.8156 4.025-4.025v-1.725c0-6.338-5.162-11.5-11.5-11.5zm0 8.05c1.919 0 3.45 1.531 3.45 3.45s-1.531 3.45-3.45 3.45-3.45-1.531-3.45-3.45 1.531-3.45 3.45-3.45z",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHEmail);
export default __webpack_public_path__ + "static/media/h-email.b4601dec8bac51a786de427fa9065c05.svg";
export { ForwardRef as ReactComponent };